export const AuthArtBackground = () => (
  <svg
    width="1044"
    height="544"
    viewBox="0 0 1044 544"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      position: 'absolute',
      top: '25%',
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 0,
    }}
  >
    <path
      d="M572.32 0.880371C268.817 8.17931 22.2283 245.323 0 544.904V588.541H119.067C119.35 330.5 328.617 121.406 586.719 121.406H1044V0.880371H572.32Z"
      fill="url(#paint0_linear_4667_41205)"
    />
    <path
      d="M586.719 121.406C328.616 121.406 119.349 330.5 119.066 588.541H244.52C244.803 399.804 397.877 246.886 586.67 246.863L586.677 246.902L1044 247.488V121.406H586.719Z"
      fill="url(#paint1_linear_4667_41205)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4667_41205"
        x1="-1.62989"
        y1="294.884"
        x2="1003.44"
        y2="100.248"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E5E1D2" />
        <stop offset="1" stopColor="#F1ECDA" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4667_41205"
        x1="1008.07"
        y1="200.394"
        x2="125.349"
        y2="390.914"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E5E1D2" />
        <stop offset="1" stopColor="#F1ECDA" stopOpacity="0.8" />
      </linearGradient>
    </defs>
  </svg>
);
